import styled from 'styled-components'
import { useForm } from "react-hook-form"
import { z } from 'zod'
import { zodResolver } from "@hookform/resolvers/zod"
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../../ui/form"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../../ui/select"
import { Button } from '../../../ui/button'
import { Input } from '../../../ui/input'
import SimpleTable from '../../components/SimpleTable'
import { Checkbox } from '../../../ui/checkbox'

const PlaceHolds = () => {

    /* 設定form item的各欄位型態 */
    const formSchema = z.object({
        type: z.string(),
        keyword: z.string(),
    })
    /* 設定form item的各欄位預設值 */
    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            type: "0",
            keyword: "",
        },
    })

    const onSubmit = (values) => {
        console.log('submit')
    }

    const ClaimsColumns = [
        {
            title: '借閱',
            dataIndex: 'Hold',
            key: 'Hold',
            render: () => {
                <FormField
                    control={form.control}
                    name="type"
                    render={({ field }) => (
                        <Checkbox />
                    )} />
            }
        },
        {
            title: '可取書地點',
            dataIndex: 'AllowdPickupLocations',
            key: 'AllowdPickupLocations',
        },
        {
            title: '書籍種類',
            dataIndex: 'ItemType',
            key: 'ItemType',
        },
        {
            title: '條碼',
            dataIndex: 'Barcode',
            key: 'Barcode',
        },
        {
            title: '原圖書館',
            dataIndex: 'HomeLibrary',
            key: 'HomeLibrary',
        },
        {
            title: '目前圖書館',
            dataIndex: 'LastLocation',
            key: 'LastLocation',
        },
        {
            title: 'Call Number',
            dataIndex: 'CallNumber',
            key: 'CallNumber',
        },
        {
            title: 'Copy Mumber',
            dataIndex: 'CopyNumber',
            key: 'CopyNumber',
        },
        {
            title: '詳情',
            dataIndex: 'Information',
            key: 'Information',
        },
    ];

    const ClaimsDataSource = [
        {
            key: '1',
            hold: 'Issue 1',
            AllowdPickupLocations: 'Details about issue 1',
            ItemType: '2023-06-01',
            Barcode: '2023-06-02',
            HomeLibrary: 'Resolved',
            LastLocation: 'Details about issue 1',
            CallNumber: '2023-06-01',
            CopyNumber: '2023-06-02',
            Information: 'Resolved',
        },
        {
            key: '2',
            hold: 'Issue 2',
            AllowdPickupLocations: 'Details about issue 2',
            ItemType: '2023-06-03',
            Barcode: '2023-06-04',
            HomeLibrary: 'Unresolved',
            LastLocation: 'Details about issue 1',
            CallNumber: '2023-06-01',
            CopyNumber: '2023-06-02',
            Information: 'Resolved',
        },
    ];

    return (
        <MainContainer>
            <Title>圖書預約</Title>
            <SubTitle>書名 by 作者</SubTitle>
            <WhiteBox>
                <SubTitle>圖書預約</SubTitle>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)}>
                        <VerContainer>
                            <ListBox>
                                <ListTitle>
                                    讀者
                                </ListTitle>
                                <ListText>
                                    John
                                </ListText>
                            </ListBox>
                            <ListBox>
                                <ListTitle>
                                    預計優先級
                                </ListTitle>
                                <ListText>
                                    <FormField
                                        control={form.control}
                                        name="type"
                                        render={({ field }) => (
                                            <FormItem>
                                                <Select defaultValue={field.value}>
                                                    <FormControl>
                                                        <SelectTrigger className="w-36 h-8">
                                                            <SelectValue />
                                                        </SelectTrigger>
                                                    </FormControl>
                                                    <SelectContent>
                                                        <SelectItem value="0"><span>全部</span></SelectItem>
                                                        <SelectItem value="1"><span>館藏</span></SelectItem>
                                                        <SelectItem value="2"><span>電子書</span></SelectItem>
                                                        <SelectItem value="3"><span>論文</span></SelectItem>
                                                    </SelectContent>
                                                </Select>
                                                <FormMessage />
                                            </FormItem>
                                        )}
                                    />
                                </ListText>
                            </ListBox>
                            <ListBox>
                                <ListTitle>
                                    備註
                                </ListTitle>
                                <ListText>
                                    <FormField
                                        control={form.control}
                                        name="type"
                                        render={({ field }) => (
                                            <Input className="w-36 h-8" />
                                        )} />

                                </ListText>
                            </ListBox>
                            <ListBox>
                                <ListTitle>
                                    取書地點
                                </ListTitle>
                                <ListText>
                                    <FormField
                                        control={form.control}
                                        name="type"
                                        render={({ field }) => (
                                            <FormItem>
                                                <Select defaultValue={field.value}>
                                                    <FormControl>
                                                        <SelectTrigger className="w-36 h-8">
                                                            <SelectValue />
                                                        </SelectTrigger>
                                                    </FormControl>
                                                    <SelectContent>
                                                        <SelectItem value="0"><span>全部</span></SelectItem>
                                                        <SelectItem value="1"><span>館藏</span></SelectItem>
                                                        <SelectItem value="2"><span>電子書</span></SelectItem>
                                                        <SelectItem value="3"><span>論文</span></SelectItem>
                                                    </SelectContent>
                                                </Select>
                                                <FormMessage />
                                            </FormItem>
                                        )}
                                    />
                                </ListText>
                            </ListBox>
                            <ListBox>
                                <ListTitle>
                                    預約到期日期
                                </ListTitle>
                                <ListText>
                                    Date Picker
                                </ListText>
                            </ListBox>
                            <ListBox>
                                <ListTitle>
                                    預約下一個可用項目
                                </ListTitle>
                                <ListText>
                                    <FormField
                                        control={form.control}
                                        name="type"
                                        render={({ field }) => (
                                            <Checkbox />
                                        )} />
                                </ListText>
                            </ListBox>
                            <ListBox>
                                <ListTitle>
                                    非優先預約
                                </ListTitle>
                                <ListText>
                                    <FormField
                                        control={form.control}
                                        name="type"
                                        render={({ field }) => (
                                            <Checkbox />
                                        )} />非優先預約不會阻止當前的借閱續借
                                </ListText>
                            </ListBox>
                            <Button type="submit" className='mytabactive rounded-full'>預約</Button>
                        </VerContainer>
                    </form>
                </Form>
                <SmallGap />
                <SubTitle>預約特定書籍</SubTitle>

                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)}>
                        <VerContainer >
                            <SimpleTable columns={ClaimsColumns} dataSource={ClaimsDataSource} />

                            <Button type="submit" className='mytabactive rounded-full'>預約</Button>
                        </VerContainer>
                    </form>
                </Form>
            </WhiteBox>
        </MainContainer>
    )
}

const ListTitle = styled.div`
    font-weight: 700;
    width: 10em;
    margin: 0.2em 1em 0.2em 0.2em;
`

const ListText = styled.div`
    margin: 0.2em;
`

const ListBox = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    // border-bottom: 1px solid #cdcdcd;
`

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
// padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const LanContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const VerContainer = styled.div`

width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.1em;
font-weight: 600;
padding: 0.5em 0em;
}
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`
const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: -webkit-fill-available;
`
const GrayText = styled.span`
color: #929292;
`
const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 700;
}
`

const SmallGap = styled.div`
height: 1em;
`

export default PlaceHolds